import Vue from 'vue'
import VueRouter from 'vue-router'

import getCookie from '../helpers/cookie'

Vue.use(VueRouter)

const AuthSignIn = () => import('../pages/Auth/SignIn')
const AuthSignInAdmin = () => import('../pages/Auth/SignInAdmin')
const AuthSignUp = () => import('../pages/Auth/SignUp')
const AuthSignUpUser = () => import('../pages/Auth/SignUp/User')
const AuthSignUpProfessional = () => import('../pages/Auth/SignUp/Professional')
const AuthPasswordRecover = () => import('../pages/Auth/Password/Recover')
const AuthPasswordReset = () => import('../pages/Auth/Password/Reset')

const Search = () => import('../pages/Search/Index')
const SearchForm = () => import('../pages/Search/Form')
const SearchOverview = () => import('../pages/Search/Overview')

const ifNotAuthenticated = (to, from, next) => {
    if (!window.user || !window.user.id) {
        next()

        return
    }
    /*let token = getCookie('token')

    if (!token) {
        next()

        return
    }*/

    // next('/')
    window.location.replace('/') // TODO Redirect to the right BO ?
}

const ifAuthenticated = (to, from, next) => {
    if (window.user && window.user.id) {
        next()

        return
    }
    /*let token = getCookie('token')

    if (token) {
        next()

        return
    }*/

    next('/login')
}

const routes = [{
    path: '/connexion/admin/:email?',
    component: AuthSignInAdmin,
    name: 'signin-admin',
    beforeEnter: ifNotAuthenticated,
}, {
    path: '/connexion/(professionnel|professionnels)/:email?',
    redirect: to => {
        // const { params } = to

        return {
            name: 'signin',
        }
    },
}, {
    path: '/connexion/:email?',
    component: AuthSignIn,
    name: 'signin',
    beforeEnter: ifNotAuthenticated,
}, {
    path: '/inscription',
    component: AuthSignUp,
    children: [{
        path: 'particulier',
        component: AuthSignUpUser,
        name: 'signup-user',
        alias: [
            '',
            'particulier/',
            'particulier/vos-informations',
            'particulier/votre-compte'
        ]
    }, {
        path: 'professionnel/:email?',
        alias: [
            'professionnel_/:email?',
            '/professionnel/creer-mon-compte/:email?',
        ],
        component: AuthSignUpProfessional,
        name: 'signup-professional',
    }],
    beforeEnter: ifNotAuthenticated,
}, {
    path: '/connexion/recuperer-mot-de-passe/:email?',
    component: AuthPasswordRecover,
    name: 'password-recover',    
}, {
    path: '/reinitialisation-du-mot-de-passe/:email/:token',
    component: AuthPasswordReset,
    name: 'password-reset',    
}, {
    path: '/recherche/validation',
    component: SearchOverview,
    alias: '/recherche/validation-et-inscription',
    children: [{
        path: '',
        component: AuthSignUpUser,
        name: 'search-overview',
    }],
    // beforeEnter: ifNotAuthenticated,
}, /*{
    path: '/recherche/validation-et-inscription',
    component: SearchOverview,
    children: [{
        path: '',
        component: AuthSignUpUser,
        name: 'signup-user',
    }],
    beforeEnter: ifNotAuthenticated,
}, */{
    path: '/recherche/:step?',
    component: Search,
    name: 'search',
}]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: '/',
    linkActiveClass: 'is-active',
})

/*
router.afterEach(to => {
    const name = to.name

    Vue.dataLayer.push({
        event: 'content-view',
        'content-name': to.fullPath,
    })
})
*/

export {
    routes,
    router,
}


// WEBPACK FOOTER //
// ./application/assets/js/site/routes/index.js